import { useLocation } from "react-router-dom";
import { Construction, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import PrivateLayout from "@/components/layout/auth/PrivateLayout";

const WorkingProgress = () => {
  const location = useLocation();
  
  // Estrai il nome della pagina dall'URL
  const pageName = location.pathname.split('/')[1] || 'page';
  const capitalizedPageName = pageName.charAt(0).toUpperCase() + pageName.slice(1);

  return (
    <PrivateLayout 
      pageTitle={capitalizedPageName}
      pageDescription="This feature is coming soon!"
    >
      <div className="max-w-md w-full mx-auto text-center p-8">
        <div className="mb-8">
          <Construction className="h-24 w-24 text-orange-500 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {capitalizedPageName}
          </h1>
          <p className="text-lg text-gray-600 mb-6">
            This feature is coming soon!
          </p>
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
            <p className="text-orange-800 text-sm">
              We're working hard to bring you this amazing feature. 
              Stay tuned for updates!
            </p>
          </div>
        </div>
        
        <div className="space-y-4">
          <Button asChild className="w-full">
            <Link to="/dashboard">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Dashboard
            </Link>
          </Button>
        </div>
      </div>
    </PrivateLayout>
  );
};

export default WorkingProgress;
